<template>
  <div>
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2727 0.00012207H1.54538C0.741718 0.00012207 0.0908203 0.65102 0.0908203 1.45468V11.6365H1.54538V1.45468H10.2727V0.00012207Z"
        fill="currentColor"
      />
      <path
        d="M12.4546 2.909H4.45456C3.65093 2.909 3 3.55989 3 4.36355V14.5454C3 15.349 3.6509 15.9999 4.45456 15.9999H12.4546C13.2582 15.9999 13.9091 15.349 13.9091 14.5454V4.36355C13.9091 3.55993 13.2582 2.909 12.4546 2.909ZM12.4546 14.5454H4.45456V4.36355H12.4546V14.5454Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CopyGrayIcon',
  props:{
    width:{
        type:Number,
        default:14
    },
    height:{
        type:Number,
        default:16
    }
  }
};
</script>
